"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const validation_1 = require("core/validation");
const React = __importStar(require("react"));
const useAmpli_1 = require("src/hooks/useAmpli");
const useKeboardSubmitHandler_1 = require("src/hooks/useKeboardSubmitHandler");
const useNavigation_1 = require("src/hooks/useNavigation");
const useWindowSize_1 = require("src/hooks/useWindowSize");
const layouts_1 = require("../shared/layouts");
const useV1Signup_1 = require("./useV1Signup");
const tabIndexesMobile = {
    firstName: 1,
    lastName: 2,
    email: 3,
    password: 4,
};
const tabIndexesDesktop = {
    email: 1,
    password: 2,
    firstName: 3,
    lastName: 4,
};
const SinglePageSignup = () => {
    const { newUser, setUser, submitUser, errors, isProcessing, birthdateRequired } = (0, useV1Signup_1.useV1Signup)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const { screenViewed, identify, resetUser, accountBlocked } = (0, useAmpli_1.useAmpli)();
    const [width] = (0, useWindowSize_1.useWindowSize)();
    const tabIndexes = width >= 1024 ? tabIndexesDesktop : tabIndexesMobile;
    (0, useKeboardSubmitHandler_1.useKeboardSubmitHandler)(submitUser);
    const [openTooltip, setOpenTooltip] = React.useState(false);
    const { email, password, birthdate, receivesNewsletter, termsAndConditionsAccepted } = newUser;
    React.useEffect(() => {
        resetUser();
        identify({ experiment_audience_fall_2024_onboarding: true });
    }, []);
    React.useEffect(() => {
        if (typeof birthdateRequired !== 'undefined') {
            // not undefined means experiment has been fetched
            identify({ experiment_audience_age_gating: birthdateRequired });
            screenViewed(useAmpli_1.AmplitudeScreenNames.SIGNUP);
        }
    }, [birthdateRequired]);
    React.useEffect(() => {
        if (errors?.termsViolated) {
            accountBlocked(errors.termsViolated, 'Signup', useAmpli_1.AmplitudeScreenNames.SIGNUP);
        }
    }, [errors?.termsViolated]);
    return (React.createElement(layouts_1.SplitWrapper, null,
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d:sui-hidden sui-flex sui-justify-between sui-mb-3 sui-items-center" },
                React.createElement(layouts_1.Logo, { className: "" }),
                React.createElement(layouts_1.Login, { onClick: navigate.goToClassicLogin })),
            React.createElement(layouts_1.FormWrapper, null,
                errors?.termsViolated && (React.createElement(snap_ui_1.Banner, { className: "sui-mt-2 sui-mb-3", sentiment: "negative", caption: "We cannot create your account at this time as it does not meet certain requirements outlined in our Terms of Service." })),
                errors?.isNetworkError && (React.createElement(snap_ui_1.Banner, { className: "sui-mt-2 sui-mb-3", sentiment: "negative", caption: "We cannot create your account at this time as it does not meet certain requirements to use TeamSnap." })),
                React.createElement("div", { className: "sui-block sui-w-full sui-mt-1" },
                    React.createElement("div", { className: "sui-hidden d:sui-flex sui-whitespace-nowrap sui-justify-between sui-items-baseline sui-mb-3" },
                        React.createElement("span", { className: "sui-heading-md" }, "Sign up to get Started!"),
                        React.createElement(layouts_1.Login, { onClick: navigate.goToClassicLogin })),
                    React.createElement("div", { className: "sui-heading-md d:sui-hidden sui-mb-3" }, "Everything your team needs, all in one place"),
                    React.createElement("div", { className: "sui-flex sui-flex-col d:sui-flex-col-reverse" },
                        React.createElement("div", { className: "sui-flex d:sui-flex-col sui-mb-2 d:sui-mb-0 name-fields" },
                            React.createElement(snap_ui_1.Input, { label: "First name", required: true, name: "firstName", className: "sui-block d:sui-w-full d:sui-mb-2 sui-mr-0.5 d:sui-mr-0", onChange: (e) => {
                                    setUser('firstName', e.target.value.replace(validation_1.SPECIAL_CHARACTERS_REGEX, ''));
                                }, placeholder: "", inputProps: { maxLength: 40, tabIndex: tabIndexes.firstName }, type: "text", value: newUser.firstName || '', errors: errors?.firstName ? [errors.firstName] : [] }),
                            React.createElement(snap_ui_1.Input, { label: "Last name", required: true, name: "lastName", className: "sui-block d:sui-w-full d:sui-mb-2 sui-ml-0.5 d:sui-ml-0", onChange: (e) => {
                                    setUser('lastName', e.target.value.replace(validation_1.SPECIAL_CHARACTERS_REGEX, ''));
                                }, placeholder: "", inputProps: { maxLength: 40, tabIndex: tabIndexes.lastName }, type: "text", value: newUser.lastName || '', errors: errors?.lastName ? [errors.lastName] : [] })),
                        React.createElement("div", { className: "login-fields" },
                            React.createElement(snap_ui_1.Input, { label: "Email address", required: true, name: "email", className: "sui-block sui-mb-2", onChange: (e) => {
                                    setUser('email', e.target.value);
                                }, placeholder: "", inputProps: {
                                    maxLength: 150,
                                    inputMode: 'email',
                                    tabIndex: tabIndexes.email,
                                }, value: email || '', type: "email", errors: errors?.email ? [errors.email] : [], autocomplete: "email" }),
                            React.createElement(snap_ui_1.Input, { label: "Create a password", required: true, name: "password", className: "sui-block sui-mb-2", helpText: "Password must include at least 8 characters.", onChange: (e) => {
                                    setUser('password', e.target.value);
                                }, placeholder: "", inputProps: { maxLength: 255, tabIndex: tabIndexes.password }, value: password || '', type: "password", errors: errors?.password ? [errors.password] : undefined, autocomplete: "new-password" }))),
                    birthdateRequired && (React.createElement("div", { className: "sui-mb-2" },
                        React.createElement(snap_ui_1.Birthdate, { className: "sui-block", name: "birthdate-validated", onChange: (e) => {
                                setUser('birthdate', e.toString());
                            }, required: true, value: birthdate || '', inputProps: { tabIndex: 5 }, size: "default", errors: errors?.birthdate ? [errors.birthdate] : [] }),
                        React.createElement("div", { className: "sui-flex" },
                            React.createElement(snap_ui_1.TooltipProvider, null,
                                React.createElement(snap_ui_1.Tooltip, { align: "start", side: "top", open: openTooltip },
                                    React.createElement(snap_ui_1.TooltipContent, null,
                                        React.createElement("div", { className: "sui-max-w-[220px]" }, "We verify age to ensure compliance with our terms of service for a safe and enjoyable app experience.")),
                                    React.createElement(snap_ui_1.TooltipTrigger, { asChild: true, onClick: () => setOpenTooltip(!openTooltip) },
                                        React.createElement("div", { className: "sui-flex help-text sui-cursor-pointer" },
                                            React.createElement(snap_ui_1.Icon, { name: "info", size: "s" }),
                                            React.createElement("span", { className: "sui-pl-1 sui-text-mobile-2" }, "Why we ask for date of birth")))))))),
                    React.createElement(snap_ui_1.Checkbox, { className: "sui-mb-2", name: "receivesNewsletter", value: "receivesNewsletter", label: "Send me occasional TeamSnap news.", extraProps: {
                            input: {
                                tabIndex: 6,
                                checked: receivesNewsletter,
                                onChange: () => {
                                    setUser('receivesNewsletter', !receivesNewsletter);
                                },
                            },
                        } }),
                    React.createElement("div", { "data-testid": "termsAndConditionsAccepted", className: "sui-mb-2" },
                        React.createElement(snap_ui_1.Checkbox, { name: "termsAndConditionsAccepted", value: "termsAndConditionsAccepted", extraProps: {
                                input: {
                                    tabIndex: 7,
                                    checked: termsAndConditionsAccepted,
                                    onChange: () => setUser('termsAndConditionsAccepted', !termsAndConditionsAccepted),
                                },
                            }, errors: errors?.termsAndConditionsAccepted ? [errors.termsAndConditionsAccepted] : [] },
                            "I agree to TeamSnap's ",
                            React.createElement("a", { href: "https://teamsnap.com/terms", target: "_blank", rel: "noreferrer", className: "linkstyle" }, "Terms of Service"),
                            ' and ',
                            React.createElement("a", { href: "https://teamsnap.com/privacy-policy", target: "_blank", rel: "noreferrer", className: "linkstyle" }, "Privacy Policy"),
                            '.')),
                    React.createElement(snap_ui_1.LabelButton, { tabIndex: 7, "data-testid": "create-account-button", className: "sui-min-w-full", labelText: "Create account", onClick: submitUser, size: "default", variantType: "primary", disabled: errors?.termsViolated, loading: isProcessing }))))));
};
exports.default = SinglePageSignup;
